/* eslint-disable @typescript-eslint/no-empty-function */
import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';

import { State, defaultState, rootReducer } from './rootReducer';
import type { AllActions } from './actions';

interface ContextType {
  state: State;
  dispatch: React.Dispatch<AllActions>
}

export const StateContext = createContext<ContextType>({
  state: defaultState,
  dispatch: () => ({}),
});

export const StateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(rootReducer, defaultState);
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <StateContext.Provider value={value}>
      {children}
    </StateContext.Provider>
  );
};

export const useAppDispatch = (): React.Dispatch<AllActions> => {
  const { dispatch } = useContext(StateContext);
  return dispatch;
};

export const useAppState = (): State => {
  const { state } = useContext(StateContext);
  return state;
};
